export default "__VITE_ASSET__DzF3qtvq__"